var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (customClass, texts) {// iterate texts
;(function(){
  var $$obj = texts;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var text = $$obj[pug_index0];
pug_html = pug_html + "\u003Cp" + (pug.attr("class", pug.classes([customClass], [true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = text) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var text = $$obj[pug_index0];
pug_html = pug_html + "\u003Cp" + (pug.attr("class", pug.classes([customClass], [true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = text) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
    }
  }
}).call(this);
}.call(this,"customClass" in locals_for_with?locals_for_with.customClass:typeof customClass!=="undefined"?customClass:undefined,"texts" in locals_for_with?locals_for_with.texts:typeof texts!=="undefined"?texts:undefined));;return pug_html;};
module.exports = template;